module.exports = __webpack_public_path__ + "4cdb17986468c17c4148094aaec827fa.svg";